/* ============================================================================
   SNG BOEKING — gedrag
   Hoort bij sections/sng-booking-v2.liquid en assets/sng-booking.css.

   Uitgangspunten (handoff §7, §8, §12, §14):

   1. De klant ziet nooit "aanvraag ontvangen" voordat Shopify de betaling
      heeft bevestigd. Stap 3 gaat rechtstreeks naar de checkout.
   2. Wat de klant ziet, staat ook in de winkelwagen. We lezen de winkelwagen
      na het opslaan onafhankelijk terug en vergelijken veld voor veld. Bij
      het kleinste verschil gaat de aanvraag niet door.
   3. De browser is nooit eigenaar van de beschikbaarheid. Hij toont wat de
      backend zegt; de bindende reservering gebeurt serverzijdig.
   4. Ingevulde gegevens gaan niet verloren bij een fout, een stap terug of
      een geannuleerde betaling.
   5. Er gaan geen persoonsgegevens of IBAN naar een beschikbaarheidsdienst.

   Geen framework, geen externe afhankelijkheden.
   ========================================================================== */

(function () {
  'use strict';

  var MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var MONTHS_SHORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
    'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var DAYS_SHORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

  var CART_TIMEOUT_MS = 15000;

  /* ── Datum- en tijdhulpmiddelen ───────────────────────────────────────────
     Nooit toISOString() voor een kalenderdag: dat kan een dag verschuiven.
     Altijd expliciet jaar / maand / dag in lokale tijd. */

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function isoFrom(year, month0, day) {
    return year + '-' + pad2(month0 + 1) + '-' + pad2(day);
  }

  function isoOf(date) {
    return isoFrom(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function parseISO(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return null;
    var year = +m[1], month0 = +m[2] - 1, day = +m[3];
    var d = new Date(year, month0, day);
    if (d.getFullYear() !== year || d.getMonth() !== month0 || d.getDate() !== day) return null;
    return d;
  }

  /* Wat een backend ook teruggeeft, hier komt "YYYY-MM-DD" uit — of null.
     Ondersteunt "2026-08-05", "05-08-2026" en de datumstring die Google Apps
     Script produceert ("Thu Jul 02 2026 02:00:00 GMT+0200 (...)"). */
  function normaliseDate(value) {
    if (value === null || value === undefined) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : isoOf(value);
    var s = String(value).trim();
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (m) {
      var short = m[1] + '-' + m[2] + '-' + m[3];
      return parseISO(short) ? short : null;
    }
    m = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/.exec(s);      // 05-08-2026 (NL)
    if (m) {
      var nl = isoFrom(+m[3], +m[2] - 1, +m[1]);
      return parseISO(nl) ? nl : null;
    }
    var d = new Date(s);
    if (isNaN(d.getTime())) return null;
    // Zulke strings staan voor middernacht van de bedoelde kalenderdag; de
    // UTC-componenten geven die dag ongeacht de tijdzone van de bezoeker.
    return isoFrom(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  /* Elk tijdslotformaat terugbrengen tot "HH:MM – HH:MM" (en-dash). */
  function normaliseSlot(value) {
    var m = /(\d{1,2})\s*[:.]\s*(\d{2})\s*[^\d]{1,4}\s*(\d{1,2})\s*[:.]\s*(\d{2})/.exec(String(value || ''));
    if (!m) return null;
    var a = +m[1], b = +m[3];
    if (a > 23 || b > 24 || +m[2] > 59 || +m[4] > 59) return null;
    return pad2(a) + ':' + m[2] + ' – ' + pad2(b) + ':' + m[4];
  }

  function dutchDate(iso) {
    var d = parseISO(iso);
    if (!d) return '';
    return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function addDays(date, n) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + n);
  }

  function euro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ── Kleine DOM-hulpjes ─────────────────────────────────────────────────── */

  function el(root, selector) { return root.querySelector(selector); }
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

  function show(node, visible) {
    if (!node) return;
    if (visible) node.removeAttribute('hidden');
    else node.setAttribute('hidden', '');
  }

  function text(node, value) {
    if (node) node.textContent = value;
  }

  /* ── Netwerk: altijd een harde time-out en een afbreekbaar verzoek ──────── */

  function request(url, options, timeoutMs) {
    options = options || {};
    var controller = null;
    try {
      controller = new AbortController();
      options.signal = options.signal || controller.signal;
    } catch (e) { /* oudere browsers: geen abort, wel time-out */ }

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) { try { controller.abort(); } catch (e) {} }
        reject(new Error('Time-out na ' + Math.round(timeoutMs / 1000) + ' seconden.'));
      }, timeoutMs);

      fetch(url, options)
        .then(function (response) {
          return response.text().then(function (body) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            if (!body) throw new Error('Leeg antwoord');
            try { return JSON.parse(body); }
            catch (e) { throw new Error('Antwoord was geen JSON'); }
          });
        })
        .then(function (data) {
          if (settled) return;
          settled = true; clearTimeout(timer); resolve(data);
        })
        .catch(function (error) {
          if (settled) return;
          settled = true; clearTimeout(timer);
          if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            reject(new Error('Geen internetverbinding'));
          } else {
            reject(error);
          }
        });
    });
  }

  /* ── Tijdzone: Europa/Amsterdam ───────────────────────────────────────────

     De klant kan in elke tijdzone zitten, maar een ophaalmoment is altijd
     Nederlandse kloktijd. En Nederland heeft zomertijd, dus een vaste +1 of +2
     is fout. We rekenen daarom met de echte zone via Intl.

     De 48-uursregel zelf is tijdzone-onafhankelijk: dat is een moment in de
     tijd (nu + 48 uur). Wat wél omgerekend moet worden, is de starttijd van een
     tijdslot: "vrijdag 13:00 in Amsterdam" is een ander moment in juli dan in
     januari. Daarom zetten we die kloktijd om naar een tijdstempel en
     vergelijken we tijdstempels.
     ────────────────────────────────────────────────────────────────────────── */

  var TZ = 'Europe/Amsterdam';

  var tzFormatter = (function () {
    try {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    } catch (e) {
      return null;   // heel oude browser: we vallen terug op lokale tijd
    }
  })();

  function tzParts(timestamp) {
    if (!tzFormatter) {
      var d = new Date(timestamp);
      return {
        year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(),
        hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds()
      };
    }
    var out = {};
    tzFormatter.formatToParts(new Date(timestamp)).forEach(function (part) {
      if (part.type !== 'literal') out[part.type] = parseInt(part.value, 10);
    });
    // Middernacht komt er bij sommige browsers uit als uur 24.
    if (out.hour === 24) out.hour = 0;
    return out;
  }

  /* Hoeveel minuten loopt Amsterdam voor op UTC, op dit moment? */
  function tzOffsetMinutes(timestamp) {
    if (!tzFormatter) return -new Date(timestamp).getTimezoneOffset();
    var p = tzParts(timestamp);
    var asIfUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return Math.round((asIfUTC - timestamp) / 60000);
  }

  /* Nederlandse kloktijd → tijdstempel. Twee rondes, omdat de offset zelf van
     het antwoord afhangt: precies op de overgangsnacht zou één ronde er een uur
     naast kunnen zitten. */
  function amsterdamTimestamp(year, month1, day, hour, minute) {
    var guess = Date.UTC(year, month1 - 1, day, hour || 0, minute || 0);
    var ts = guess - tzOffsetMinutes(guess) * 60000;
    ts = guess - tzOffsetMinutes(ts) * 60000;
    return ts;
  }

  /* Welke kalenderdag is het nú in Nederland? */
  function amsterdamToday(now) {
    var p = tzParts(typeof now === 'number' ? now : Date.now());
    return { year: p.year, month: p.month, day: p.day };
  }

  /* Kalenderdag in Nederland, n dagen vooruit. */
  function amsterdamDatePlus(days, now) {
    var t = amsterdamToday(now);
    // Middaguur gebruiken zodat een zomertijdsprong nooit een dag verschuift.
    var noon = amsterdamTimestamp(t.year, t.month, t.day, 12, 0);
    var p = tzParts(noon + days * 86400000);
    return { year: p.year, month: p.month, day: p.day };
  }

  function isoFromParts(p) {
    return isoFrom(p.year, p.month - 1, p.day);
  }

  /* Weekdag (0 = zondag) van een kalenderdag in Nederland. */
  function weekdayOfISO(iso) {
    var parsed = parseISO(iso);
    if (!parsed) return null;
    return new Date(Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())).getUTCDay();
  }

  /* ── Validatie ────────────────────────────────────────────────────────────
     Alleen na blur en bij verzenden — niet op elke toetsaanslag (handoff §8). */

  var POSTCODE_RE = /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

  function normalisePostcode(value) {
    return String(value || '').replace(/\s+/g, '').toUpperCase();
  }

  function formatPostcode(value) {
    var clean = normalisePostcode(value);
    if (clean.length === 6) return clean.slice(0, 4) + ' ' + clean.slice(4);
    return clean;
  }

  /* IBAN: structuur plus de officiële mod-97-controle. Een typefout in het
     rekeningnummer kost een mislukte uitbetaling, dus dit hoort hier thuis. */
  function isValidIBAN(value) {
    var iban = String(value || '').replace(/[\s.-]/g, '').toUpperCase();
    if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(iban)) return false;
    var rearranged = iban.slice(4) + iban.slice(0, 4);
    var digits = '';
    for (var i = 0; i < rearranged.length; i++) {
      var c = rearranged.charAt(i);
      digits += (c >= 'A' && c <= 'Z') ? String(c.charCodeAt(0) - 55) : c;
    }
    // Stapsgewijze modulo, want het getal past niet in een Number.
    var remainder = 0;
    for (var j = 0; j < digits.length; j += 7) {
      remainder = parseInt(String(remainder) + digits.substr(j, 7), 10) % 97;
    }
    return remainder === 1;
  }

  function isValidPhone(value) {
    var digits = String(value || '').replace(/[^\d]/g, '');
    return digits.length >= 8 && digits.length <= 15;
  }

  /* ── Afstandscontrole ─────────────────────────────────────────────────────
     Doel: operationele screening, geen navigatie. Een hemelsbrede straal is
     daarvoor genoeg; we hebben geen betaalde routeservice nodig.

     Postcode → coördinaten via de PDOK Locatieserver. Dat is de open
     overheidsdienst voor Nederlandse adressen: geen sleutel, geen kosten,
     CORS staat open. Er gaat alleen een postcode heen, geen naam of adres.

     Alle instellingen (herkomst, straal, teksten) komen uit de sectie-
     instellingen; er staat nergens een losse 50 in dit bestand. */

  /* Gemeten op 11 augustus 2026, 5 opeenvolgende metingen vanaf een NL-verbinding:
     70, 81, 96, 103 en 113 ms, alle vijf HTTP 200 met hetzelfde resultaat.
     6 seconden is dus ruim vijftig keer de normale responstijd — genoeg marge
     voor een trage mobiele verbinding, zonder de klant onnodig lang te laten
     wachten op iets dat kapot is. */
  var GEOCODE_TIMEOUT_MS = 6000;

  /* Cache voor de duur van dit paginabezoek. Bewust een Map in het geheugen:
     locatiegegevens horen niet in localStorage, sessionStorage of een cookie.
     Alleen geslaagde opzoekingen worden bewaard — een storing mag niet blijven
     plakken. Dezelfde postcode twee keer opvragen kost dus één verzoek. */
  var geocodeCache = new Map();
  var geocodeInFlight = new Map();

  function parseGeocodeResponse(data) {
    var docs = (data && data.response && data.response.docs) || [];
    if (!docs.length) return { found: false };
    // "POINT(4.90008488 52.37881215)" — lengtegraad staat vooraan.
    var m = /POINT\(\s*([-\d.]+)\s+([-\d.]+)\s*\)/.exec(String(docs[0].centroide_ll || ''));
    if (!m) return { found: false };
    return {
      found: true,
      lng: parseFloat(m[1]),
      lat: parseFloat(m[2]),
      name: docs[0].weergavenaam || ''
    };
  }

  /* Eén enkele opzoeking. Resultaten:
       {found:true, lat, lng}   → gevonden
       {found:false}            → PDOK antwoordde netjes, maar kent deze postcode niet
       throw                    → technische storing (netwerk, time-out, 5xx)
     Dat onderscheid is belangrijk: "niet gevonden" is géén storing en mag dus
     niet opnieuw geprobeerd worden. */
  function geocodeOnce(baseUrl, postcode, signal) {
    var url = baseUrl
      + (baseUrl.indexOf('?') === -1 ? '?' : '&')
      + 'q=' + encodeURIComponent(postcode)
      + '&fq=type:postcode&rows=1&fl=weergavenaam,centroide_ll';

    return request(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      signal: signal
    }, GEOCODE_TIMEOUT_MS).then(parseGeocodeResponse);
  }

  function geocodePostcode(baseUrl, postcode, signal) {
    var key = normalisePostcode(postcode);

    if (geocodeCache.has(key)) return Promise.resolve(geocodeCache.get(key));
    // Loopt er al een verzoek voor deze postcode? Daarop meeliften in plaats
    // van een tweede identiek verzoek te sturen.
    if (geocodeInFlight.has(key)) return geocodeInFlight.get(key);

    var pending = geocodeOnce(baseUrl, key, signal)
      .catch(function (error) {
        // Eén nette herkansing bij een technische storing. Geen lus: als ook
        // de tweede poging faalt, is het een storing en zeggen we dat gewoon.
        if (signal && signal.aborted) throw error;
        return geocodeOnce(baseUrl, key, signal);
      })
      .then(function (result) {
        if (result && result.found) geocodeCache.set(key, result);
        geocodeInFlight.delete(key);
        return result;
      })
      .catch(function (error) {
        geocodeInFlight.delete(key);
        throw error;
      });

    geocodeInFlight.set(key, pending);
    return pending;
  }

  /* Hemelsbrede afstand in kilometers (haversine). */
  function distanceKm(a, b) {
    var R = 6371;
    var toRad = function (deg) { return (deg * Math.PI) / 180; };
    var dLat = toRad(b.lat - a.lat);
    var dLng = toRad(b.lng - a.lng);
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  /* ── De boeking zelf ──────────────────────────────────────────────────── */

  function initBooking(root) {
    var configNode = el(root, '[data-sng-config]');
    if (!configNode) return;

    var config;
    try { config = JSON.parse(configNode.textContent); }
    catch (e) { return; }

    var slots = (config.slots || [])
      .map(function (s) { return normaliseSlot(s); })
      .filter(function (s, index, list) { return s && list.indexOf(s) === index; });
    if (!slots.length) slots = ['08:00 – 12:00', '12:00 – 16:00', '16:00 – 20:00'];

    var leadMs = (config.leadHours || 48) * 3600 * 1000;

    /* Eén plek waar de planningsregels vandaan komen. Alles instelbaar in de
       Theme Editor; nergens anders in dit bestand staan openingsdagen,
       geblokkeerde datums of de horizon nog een keer. */
    var schedule = {
      weekdays: (config.schedule && config.schedule.weekdays) || [1, 2, 3, 4, 5],
      blocked: ((config.schedule && config.schedule.blocked) || [])
        .map(function (d) { return normaliseDate(d); })
        .filter(Boolean),
      horizonDays: (config.schedule && config.schedule.horizonDays) || 21
    };

    var refs = {
      form: el(root, '[data-booking-form]'),
      live: el(root, '[data-live-region]'),
      summary: el(root, '[data-error-summary]'),
      summaryTitle: el(root, '[data-error-title]'),
      summaryList: el(root, '[data-error-list]'),
      postcode: el(root, '[data-field="postcode"]'),
      postcodeBtn: el(root, '[data-check-postcode]'),
      postcodeResult: el(root, '[data-postcode-result]'),
      datesWrap: el(root, '[data-dates-wrap]'),
      dates: el(root, '[data-dates]'),
      moreDates: el(root, '[data-more-dates]'),
      timesWrap: el(root, '[data-times-wrap]'),
      times: el(root, '[data-times]'),
      bagsWrap: el(root, '[data-bags-wrap]'),
      bags: el(root, '[data-field="bags"]'),
      payBtn: el(root, '[data-pay]'),
      estimateNote: el(root, '[data-estimate-note]')
    };

    var state = {
      step: 1,
      postcode: '',
      postcodeStatus: 'idle',   // idle | checking | ok | ver | onbekend | invalid | geen
      distanceKm: null,
      dateISO: null,
      slot: null,
      windowDays: config.windowDays || 21,
      bookingId: null,
      busy: false
    };

    /* ── Geen opslag van klantgegevens ────────────────────────────────────────
       Naam, adres, telefoon, e-mail en IBAN worden NERGENS bewaard: niet in
       localStorage, niet in sessionStorage, niet in een cookie. De gegevens
       leven alleen in de velden op deze pagina, zolang de klant hier is.

       Binnen één boeking blijft alles staan — de drie stappen zijn gewoon
       blokken op dezelfde pagina, dus heen en weer lopen via "Wijzig" verandert
       niets aan de invoer. Verlaat de klant de pagina, dan is alles weg.

       Dit ruimt op wat een eerdere versie nog kon achterlaten. */
    function purgeLegacyStorage() {
      try {
        var stores = [window.sessionStorage, window.localStorage];
        stores.forEach(function (store) {
          if (!store) return;
          for (var i = store.length - 1; i >= 0; i--) {
            var key = store.key(i);
            if (key && (key.indexOf('sng.booking') === 0 || key === 'sngLogboek')) {
              store.removeItem(key);
            }
          }
        });
      } catch (e) { /* privémodus: niets te wissen */ }
    }

    /* Alles leegmaken en terug naar stap 1. Wordt gebruikt bij een nieuw bezoek
       en bij terugkeer uit de back/forward-cache. */
    function resetForm() {
      all(root, 'input[data-field], textarea[data-field]').forEach(function (node) {
        if (node.type === 'checkbox' || node.type === 'radio') node.checked = false;
        else if (node.getAttribute('data-field') === 'bags') node.value = config.bags.default;
        else node.value = '';
      });
      all(root, '[data-charity]').forEach(function (node) { node.checked = false; });
      var firstPayout = el(root, '[data-payout]');
      if (firstPayout) firstPayout.checked = true;
      syncPayoutPanels();

      ['postcode', 'date', 'time', 'bags', 'first', 'last', 'street', 'house', 'city',
        'email', 'phone', 'iban', 'charity', 'ack'].forEach(clearFieldError);
      clearSummary();

      state.postcode = '';
      state.postcodeStatus = 'idle';
      state.distanceKm = null;
      state.postcodeSeq = (state.postcodeSeq || 0) + 1;
      state.dateISO = null;
      state.slot = null;
      state.bookingId = null;

      show(refs.postcodeResult, false);
      show(refs.datesWrap, false);
      show(refs.timesWrap, false);
      show(refs.bagsWrap, false);
      gotoStep(1, { scroll: false });
    }

    /* ── Meldingen ───────────────────────────────────────────────────────── */

    function announce(message) {
      if (refs.live) refs.live.textContent = message;
    }

    function clearFieldError(name) {
      var node = el(root, '[data-error-for="' + name + '"]');
      if (node) { node.textContent = ''; show(node, false); }
      var input = el(root, '[data-field="' + name + '"]');
      if (input) input.removeAttribute('aria-invalid');
      var group = el(root, '[data-group="' + name + '"]');
      if (group) group.classList.remove('is-invalid');
    }

    function setFieldError(name, message) {
      var node = el(root, '[data-error-for="' + name + '"]');
      if (node) { node.textContent = message; show(node, true); }
      var input = el(root, '[data-field="' + name + '"]');
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function clearSummary() {
      show(refs.summary, false);
      if (refs.summaryList) refs.summaryList.innerHTML = '';
    }

    /* Foutensamenvatting boven de stap, met sprongen naar de velden.
       De focus verspringt ernaartoe, zodat een schermlezer hem voorleest. */
    function showSummary(title, problems, options) {
      options = options || {};
      if (!refs.summary || !refs.summaryList) return;
      text(refs.summaryTitle, title);
      refs.summaryList.innerHTML = '';

      problems.forEach(function (problem) {
        var li = document.createElement('li');
        if (problem.field) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'sng-book__alert-link';
          button.textContent = problem.message;
          button.addEventListener('click', function () { focusField(problem.field); });
          li.appendChild(button);
        } else {
          li.textContent = problem.message;
        }
        refs.summaryList.appendChild(li);
      });

      show(refs.summary, true);
      if (options.focus !== false) {
        refs.summary.focus();
        try { refs.summary.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      }
      announce(title);
    }

    function focusField(name) {
      var target = el(root, '[data-field="' + name + '"]');
      if (name === 'date') target = el(root, '[data-dates] button:not([disabled])');
      if (name === 'time') target = el(root, '[data-times] button:not([disabled])');
      if (name === 'payout') target = el(root, '[data-payout]');
      if (name === 'charity') target = el(root, '[data-charity]');
      if (!target) return;
      try { target.focus({ preventScroll: false }); } catch (e) { target.focus(); }
    }

    /* ── Stappen ─────────────────────────────────────────────────────────── */

    function gotoStep(step, options) {
      options = options || {};
      state.step = step;

      all(root, '[data-step]').forEach(function (node) {
        show(node, Number(node.getAttribute('data-step')) === step);
      });
      all(root, '[data-progress]').forEach(function (node) {
        var index = Number(node.getAttribute('data-progress'));
        node.classList.toggle('is-done', index < step);
        if (index === step) node.setAttribute('aria-current', 'step');
        else node.removeAttribute('aria-current');
      });

      if (step === 3) renderReview();
      if (!options.keepErrors) clearSummary();

      var titles = { 1: 'Waar & wanneer', 2: 'Gegevens & uitbetaling', 3: 'Controleren & betalen' };
      announce('Stap ' + step + ' van 3: ' + titles[step]);
      if (document.title.indexOf(' — ') !== -1) {
        document.title = titles[step] + document.title.slice(document.title.indexOf(' — '));
      }

      if (options.focus) {
        focusField(options.focus);
      } else if (options.scroll !== false) {
        try { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
        catch (e) { window.scrollTo(0, 0); }
      }
    }

    /* ── Postcode ────────────────────────────────────────────────────────── */

    function renderPostcodeResult(kind, message, heading) {
      if (!refs.postcodeResult) return;
      refs.postcodeResult.className = 'sng-book__result sng-book__result--' + kind;
      refs.postcodeResult.innerHTML = '';

      if (heading) {
        var h = document.createElement('p');
        h.className = 'sng-book__result-title';
        h.textContent = heading;
        refs.postcodeResult.appendChild(h);
      }

      var p = document.createElement('p');
      p.className = 'sng-book__result-text';
      p.textContent = message;
      refs.postcodeResult.appendChild(p);

      show(refs.postcodeResult, true);
    }

    /* Postcode → coördinaten → afstand tot de herkomst → binnen of buiten de
       straal. Faalt de geocoder, dan is dat nadrukkelijk GEEN afwijzing: de
       klant gaat gewoon verder en de planning kijkt er later naar.

       De vier uitkomsten zijn bewust van elkaar gescheiden:
         ok            binnen de straal
         ver           buiten de straal — waarschuwing, geen blokkade
         nietgevonden  PDOK kent de postcode niet (geen storing)
         onbekend      technische storing — geen uitspraak over de afstand */
    function measureDistance(postcode) {
      var area = config.serviceArea || {};
      // Breedte- en lengtegraad zijn tekstvelden in de Theme Editor; een lege
      // of vertypte waarde mag geen stille onzin-afstand opleveren.
      var originLat = Number(area.originLat);
      var originLng = Number(area.originLng);

      if (!area.distanceCheck || !area.geocodeUrl || isNaN(originLat) || isNaN(originLng)) {
        return Promise.resolve({ status: 'ok', km: null });
      }

      return geocodePostcode(area.geocodeUrl, postcode)
        .then(function (point) {
          if (!point || !point.found) return { status: 'nietgevonden', km: null };
          var km = distanceKm({ lat: originLat, lng: originLng }, point);
          return { status: km <= Number(area.radiusKm) ? 'ok' : 'ver', km: km };
        })
        .catch(function () {
          return { status: 'onbekend', km: null };
        });
    }

    function checkPostcode(options) {
      options = options || {};
      var raw = refs.postcode ? refs.postcode.value : '';
      var clean = normalisePostcode(raw);

      clearFieldError('postcode');

      // Geen enkel netwerkverzoek bij een ongeldig formaat (handoff §14.1).
      if (!POSTCODE_RE.test(clean)) {
        state.postcodeStatus = 'invalid';
        state.postcode = '';
        setFieldError('postcode', config.messages.postcodeInvalid);
        show(refs.postcodeResult, false);
        show(refs.datesWrap, false);
        show(refs.timesWrap, false);
        show(refs.bagsWrap, false);
        if (!options.silent) {
          showSummary('Controleer je postcode', [
            { field: 'postcode', message: config.messages.postcodeInvalid }
          ]);
        }
        return Promise.resolve(false);
      }

      state.postcode = clean;
      if (refs.postcode) refs.postcode.value = formatPostcode(clean);
      // Het adresblok in stap 2 toont dezelfde postcode, alleen-lezen.
      var mirrored = el(root, '[data-field="postcode2"]');
      if (mirrored) mirrored.value = formatPostcode(clean);

      state.postcodeStatus = 'checking';
      clearSummary();
      renderPostcodeResult('checking', config.messages.postcodeChecking);
      announce('We controleren je postcode.');
      if (refs.postcodeBtn) refs.postcodeBtn.disabled = true;

      /* Alleen de locatiecontrole is nog een netwerkverzoek. Datums en
         tijdsloten worden lokaal berekend en staan er dus meteen. */

      // Volgnummer: een laat antwoord van een óúdere postcode mag de toestand
      // van een nieuwere postcode nooit overschrijven.
      state.postcodeSeq = (state.postcodeSeq || 0) + 1;
      var seq = state.postcodeSeq;
      var current = function () { return seq === state.postcodeSeq; };

      return measureDistance(clean).then(function (distance) {
        if (!current()) return false;
        if (refs.postcodeBtn) refs.postcodeBtn.disabled = false;

        state.distanceKm = distance.km;
        state.postcodeStatus = distance.status;   // ok | ver | onbekend | nietgevonden
        renderDates();

        var kind = 'ok';
        var message = config.messages.postcodeSupported;
        var heading = '';

        if (distance.status === 'ver') {
          // Buiten het standaardgebied: een waarschuwing, geen afwijzing.
          // De klant mag gewoon door; de planning beoordeelt het achteraf.
          kind = 'far';
          heading = config.messages.farHeading;
          message = config.messages.farBody
            .replace('[km]', Math.round(distance.km))
            .replace('[straal]', config.serviceArea.radiusKm)
            .replace('[plaats]', config.serviceArea.originName);
        } else if (distance.status === 'nietgevonden') {
          // PDOK antwoordde netjes maar kent deze postcode niet. Dat is iets
          // anders dan een storing, en zeker geen uitspraak over de afstand.
          kind = 'unknown';
          message = config.messages.postcodeNotFound;
        } else if (distance.status === 'onbekend') {
          // Technische storing bij het opzoeken van de locatie.
          kind = 'unknown';
          message = config.messages.locationUncheckable;
        }

        renderPostcodeResult(kind, message, heading);
        show(refs.datesWrap, true);
        show(refs.bagsWrap, true);
        if (state.dateISO) { renderTimes(); show(refs.timesWrap, true); }
        announce((heading ? heading + '. ' : '') + message);
        return true;
      });
    }

    /* ── Planning: welke dagen en tijden mag de klant kiezen? ─────────────────

       Alles wordt hier lokaal berekend. Er is geen enkele externe aanroep meer
       nodig om datums of tijdsloten te tonen; dat scheelde in de praktijk 2 tot
       15 seconden wachten.

       Vier regels bepalen samen wat de klant ziet:
         1. de rollende 48-uursregel (nu + 48 uur, op de minuut nauwkeurig);
         2. de dagen van de week waarop we rijden;
         3. handmatig geblokkeerde datums;
         4. hoe ver vooruit er geboekt mag worden.

       Belangrijk: dit is géén beschikbaarheid. Twee klanten kunnen hetzelfde
       moment aanvragen. Dat is een bewuste keuze — het blijven aanvrágen, en de
       planning bepaalt wat er daadwerkelijk bevestigd wordt.
       ──────────────────────────────────────────────────────────────────────── */

    // Testhaakje: staat er een vast "nu", dan rekenen we daarmee. Alleen de
    // geautomatiseerde tests zetten dit; in productie is het altijd leeg.
    function nowMs() {
      return (window.__SNG_NOW__ != null) ? window.__SNG_NOW__ : Date.now();
    }

    function earliestAllowed() { return nowMs() + leadMs; }

    /* Starttijd van een tijdslot als tijdstempel, gerekend in Nederlandse
       kloktijd. "vrijdag 13:00" is in de zomer een ander moment dan in de
       winter; daarom via de tijdzone en niet via de klok van de bezoeker. */
    function slotStartTs(iso, slot) {
      var parsed = parseISO(iso);
      var normalised = normaliseSlot(slot);
      if (!parsed || !normalised) return null;
      return amsterdamTimestamp(
        parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate(),
        +normalised.slice(0, 2), +normalised.slice(3, 5)
      );
    }

    /* De kern van de 48-uursregel: vergelijk het STARTMOMENT van het tijdslot
       met nu + 48 uur. Dus niet "vandaag plus twee kalenderdagen" — als het nu
       12:44 is, valt het slot van 12:00 over twee dagen er nog buiten en dat
       van 13:00 er net binnen. */
    function slotInLeadTime(iso, slot) {
      var start = slotStartTs(iso, slot);
      return start !== null && start >= earliestAllowed();
    }

    function isBlockedDate(iso) {
      return schedule.blocked.indexOf(iso) !== -1;
    }

    function isOpenWeekday(iso) {
      var wd = weekdayOfISO(iso);
      return wd !== null && schedule.weekdays.indexOf(wd) !== -1;
    }

    function dayBookable(iso) {
      if (!isOpenWeekday(iso)) return false;
      if (isBlockedDate(iso)) return false;
      return slots.some(function (slot) { return slotInLeadTime(iso, slot); });
    }

    /* Waarom kan deze dag niet? Elke reden krijgt zijn eigen woord, zodat de
       klant niet hoeft te raden. */
    function dayBlockedReason(iso) {
      if (!isOpenWeekday(iso)) return 'gesloten';
      if (isBlockedDate(iso)) return 'geen plek';
      return 'te snel';
    }

    function dayBlockedLabel(reason) {
      if (reason === 'gesloten') return 'we rijden op deze dag niet';
      if (reason === 'geen plek') return 'deze dag is niet beschikbaar';
      return 'valt binnen onze voorbereidingstijd van ' + config.leadHours + ' uur';
    }

    function renderDates() {
      if (!refs.dates) return;
      var fragment = document.createDocumentFragment();
      var openCount = 0;
      var now = nowMs();

      for (var offset = 0; offset <= state.windowDays; offset++) {
        var parts = amsterdamDatePlus(offset, now);
        var iso = isoFromParts(parts);
        var bookable = dayBookable(iso);
        if (bookable) openCount++;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sng-book__date';
        button.setAttribute('data-date', iso);
        button.disabled = !bookable;
        if (state.dateISO === iso && bookable) {
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
        } else {
          button.setAttribute('aria-pressed', 'false');
        }

        var weekday = document.createElement('span');
        weekday.className = 'sng-book__date-day';
        weekday.textContent = DAYS_SHORT[weekdayOfISO(iso)];

        var number = document.createElement('span');
        number.className = 'sng-book__date-num';
        number.textContent = String(parts.day);

        var month = document.createElement('span');
        month.className = 'sng-book__date-month';
        month.textContent = MONTHS_SHORT[parts.month - 1];

        button.appendChild(weekday);
        button.appendChild(number);
        button.appendChild(month);

        var reason = bookable ? null : dayBlockedReason(iso);
        if (!bookable) {
          var note = document.createElement('span');
          note.className = 'sng-book__date-note';
          note.textContent = reason;
          button.appendChild(note);
        }

        // Volledige datum plus reden voor schermlezers; losse cijfers zijn te karig.
        var label = document.createElement('span');
        label.className = 'sng-visually-hidden';
        label.textContent = dutchDate(iso) + (bookable ? '' : ' — ' + dayBlockedLabel(reason));
        button.appendChild(label);

        fragment.appendChild(button);
      }

      refs.dates.innerHTML = '';

      /* Geen enkele dag te kiezen binnen het getoonde venster. Dat kan echt
         gebeuren: staan alle rijdagen uit, of is alles handmatig geblokkeerd,
         dan blijft er niets over. Een raster van grijze knoppen laat de klant
         dan raden wat er mis is — daarom in dat geval alleen de uitleg. */
      if (openCount) {
        refs.dates.appendChild(fragment);
      } else {
        var empty = document.createElement('p');
        empty.className = 'sng-book__dates-empty';
        empty.textContent = config.messages.noDates;
        refs.dates.appendChild(empty);

        if (config.serviceArea.contactUrl) {
          var link = document.createElement('a');
          link.className = 'sng-link sng-book__dates-empty-link';
          link.href = config.serviceArea.contactUrl;
          link.textContent = 'Neem contact met ons op';
          refs.dates.appendChild(link);
        }
      }

      show(refs.moreDates, state.windowDays < schedule.horizonDays);

      // Een eerder gekozen datum die inmiddels niet meer mag, blijft niet stil
      // geselecteerd staan.
      if (state.dateISO && !dayBookable(state.dateISO)) {
        state.dateISO = null;
        state.slot = null;
        show(refs.timesWrap, false);
      }
      return openCount;
    }

    function renderTimes() {
      if (!refs.times || !state.dateISO) return;
      var fragment = document.createDocumentFragment();
      var openCount = 0;

      slots.forEach(function (slot) {
        var tooSoon = !slotInLeadTime(state.dateISO, slot);
        if (!tooSoon) openCount++;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sng-book__time';
        button.setAttribute('data-slot', slot);
        button.disabled = tooSoon;
        var selected = state.slot === slot && !tooSoon;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');

        var label = document.createElement('span');
        label.className = 'sng-book__time-label';
        label.textContent = slot;
        button.appendChild(label);

        if (tooSoon) {
          // Uitgeschakelde tijden krijgen zichtbare tekst, niet alleen grijs.
          var note = document.createElement('span');
          note.className = 'sng-book__time-note';
          note.textContent = 'te snel';
          button.appendChild(note);

          var reason = document.createElement('span');
          reason.className = 'sng-visually-hidden';
          reason.textContent = ' — valt binnen onze voorbereidingstijd van '
            + config.leadHours + ' uur';
          button.appendChild(reason);
        }

        fragment.appendChild(button);
      });

      refs.times.innerHTML = '';
      refs.times.appendChild(fragment);

      if (!openCount) {
        var empty = document.createElement('p');
        empty.className = 'sng-book__times-empty';
        empty.textContent = 'Op deze dag kan het niet meer op tijd. Kies een latere datum.';
        refs.times.appendChild(empty);
      }
      if (state.slot && !slotInLeadTime(state.dateISO, state.slot)) {
        state.slot = null;
      }
    }

    function selectDate(iso) {
      if (!dayBookable(iso)) return;
      state.dateISO = iso;
      state.slot = null;
      clearFieldError('date');
      renderDates();
      renderTimes();
      show(refs.timesWrap, true);
      show(refs.bagsWrap, true);
      announce(dutchDate(iso) + ' gekozen. Kies nu een tijdslot.');
    }

    function selectSlot(slot) {
      if (!state.dateISO) return;
      if (!slotInLeadTime(state.dateISO, slot)) return;
      state.slot = slot;
      clearFieldError('time');
      renderTimes();
      announce(slot + ' gekozen op ' + dutchDate(state.dateISO) + '.');
    }

    /* ── Uitbetaalkeuze ──────────────────────────────────────────────────── */

    function currentPayout() {
      var checked = el(root, '[data-payout]:checked');
      return checked ? checked.value : 'tikkie';
    }

    function syncPayoutPanels() {
      var payout = currentPayout();
      all(root, '[data-payout-panel]').forEach(function (panel) {
        var match = panel.getAttribute('data-payout-panel') === payout;
        show(panel, match);
        if (!match) {
          // Velden die niet meer van toepassing zijn, leegmaken en hun fout
          // opruimen — zo kan er nooit een IBAN meereizen bij een donatie.
          all(panel, 'input[type="text"]').forEach(function (input) { input.value = ''; });
          all(panel, 'input[type="radio"]').forEach(function (input) { input.checked = false; });
        }
      });
      clearFieldError('iban');
      clearFieldError('charity');
      all(root, '.sng-book__payout').forEach(function (label) {
        var input = el(label, '[data-payout]');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
    }

    function payoutSummary() {
      var payout = currentPayout();
      if (payout === 'bank') {
        var iban = el(root, '[data-field="iban"]');
        // Spaties eruit vóór het afkorten, anders komt er zoiets als
        // "•••• 3 00" te staan in plaats van de laatste vier cijfers.
        var value = iban ? iban.value.replace(/[\s.-]/g, '').toUpperCase() : '';
        var masked = value.length > 4 ? '•••• ' + value.slice(-4) : value;
        return { label: 'Bankrekening', detail: masked ? 'IBAN ' + masked : '' };
      }
      if (payout === 'donatie') {
        var charity = el(root, '[data-charity]:checked');
        return { label: 'Doneren', detail: charity ? charity.value : '' };
      }
      return { label: 'Tikkie', detail: 'Betaalverzoek op je telefoon' };
    }

    /* ── Validatie per stap ──────────────────────────────────────────────── */

    function value(name) {
      var node = el(root, '[data-field="' + name + '"]');
      return node ? String(node.value || '').trim() : '';
    }

    function validateStep1() {
      var problems = [];
      ['postcode', 'date', 'time', 'bags'].forEach(clearFieldError);

      // ok / ver / onbekend laten allemaal door: alleen 'ver' krijgt een
      // waarschuwing, en 'geen' is de enige echte blokkade.
      if (['ok', 'ver', 'onbekend', 'nietgevonden'].indexOf(state.postcodeStatus) === -1) {
        problems.push({ field: 'postcode', message: 'Controleer eerst je postcode.' });
      }
      if (!state.dateISO) {
        problems.push({ field: 'date', message: 'Kies een gewenste datum.' });
      } else if (!dayBookable(state.dateISO)) {
        problems.push({ field: 'date', message: config.messages.slotExpired.replace(/\[uren\]/g, config.leadHours) });
      }
      if (state.dateISO && !state.slot) {
        problems.push({ field: 'time', message: 'Kies een tijdslot.' });
      } else if (state.dateISO && state.slot && !slotInLeadTime(state.dateISO, state.slot)) {
        problems.push({ field: 'time', message: config.messages.slotExpired.replace(/\[uren\]/g, config.leadHours) });
      }

      var bags = parseInt(value('bags'), 10);
      if (isNaN(bags) || bags < config.bags.min || bags > config.bags.max) {
        problems.push({
          field: 'bags',
          message: 'Vul een aantal zakken in tussen ' + config.bags.min + ' en ' + config.bags.max + '.'
        });
      }

      problems.forEach(function (problem) { setFieldError(problem.field, problem.message); });
      return problems;
    }

    function validateStep2() {
      var problems = [];
      ['first', 'last', 'street', 'house', 'city', 'email', 'phone', 'iban', 'charity']
        .forEach(clearFieldError);

      if (!value('first')) problems.push({ field: 'first', message: 'Vul je voornaam in.' });
      if (!value('last')) problems.push({ field: 'last', message: 'Vul je achternaam in.' });
      if (!value('street')) problems.push({ field: 'street', message: 'Vul je straatnaam in.' });
      if (!value('house')) problems.push({ field: 'house', message: 'Vul je huisnummer in.' });
      if (!value('city')) problems.push({ field: 'city', message: 'Vul je plaatsnaam in.' });

      var email = value('email');
      if (!email) problems.push({ field: 'email', message: 'Vul je e-mailadres in — daar sturen we je bevestiging naartoe.' });
      else if (!EMAIL_RE.test(email)) problems.push({ field: 'email', message: 'Dit e-mailadres klopt niet. Controleer het op typefouten.' });

      var phone = value('phone');
      if (!phone) problems.push({ field: 'phone', message: 'Vul je telefoonnummer in, voor als de chauffeur je moet bereiken.' });
      else if (!isValidPhone(phone)) problems.push({ field: 'phone', message: 'Dit telefoonnummer klopt niet. Gebruik bijvoorbeeld 06 12345678.' });

      var payout = currentPayout();
      if (payout === 'bank') {
        var iban = value('iban');
        if (!iban) problems.push({ field: 'iban', message: 'Vul je IBAN in voor de overboeking.' });
        else if (!isValidIBAN(iban)) problems.push({ field: 'iban', message: 'Dit IBAN klopt niet. Controleer het op je bankpas of in je bankapp.' });
      }
      if (payout === 'donatie' && !el(root, '[data-charity]:checked')) {
        problems.push({ field: 'charity', message: 'Kies een goed doel om aan te doneren.' });
      }

      problems.forEach(function (problem) { setFieldError(problem.field, problem.message); });
      return problems;
    }

    function validateStep3() {
      var problems = [];
      clearFieldError('ack');
      var ack = el(root, '[data-field="ack"]');
      if (!ack || !ack.checked) {
        problems.push({ field: 'ack', message: 'Bevestig eerst dat je datum en tijd kloppen en dat je €1 betaalt.' });
        setFieldError('ack', problems[0].message);
      }
      return problems;
    }

    /* ── Overzicht (stap 3) ──────────────────────────────────────────────── */

    function renderReview() {
      var moment = (state.dateISO && state.slot)
        ? dutchDate(state.dateISO) + ', ' + state.slot
        : 'Nog niet gekozen';
      text(el(root, '[data-review-moment]'), moment);

      var address = [value('street'), value('house')].filter(Boolean).join(' ');
      var place = [formatPostcode(state.postcode), value('city')].filter(Boolean).join(' ');
      text(el(root, '[data-review-address]'), [address, place].filter(Boolean).join(', ') || '—');

      var contact = [value('first') + ' ' + value('last'), value('email'), value('phone')]
        .map(function (part) { return String(part).trim(); })
        .filter(Boolean).join(' · ');
      text(el(root, '[data-review-contact]'), contact || '—');

      var bags = parseInt(value('bags'), 10) || config.bags.default;
      text(el(root, '[data-review-bags]'), bags + (bags === 1 ? ' zak' : ' zakken'));

      var payout = payoutSummary();
      text(el(root, '[data-review-payout]'),
        payout.detail ? payout.label + ' — ' + payout.detail : payout.label);

      if (refs.estimateNote && config.payout.estimateEnabled && config.payout.perBag > 0) {
        var estimate = bags * config.payout.perBag;
        var currentPayoutType = currentPayout();
        text(refs.estimateNote, currentPayoutType === 'donatie'
          ? 'Geschatte donatie: ongeveer ' + euro(estimate) + '. Dit is een schatting, geen toezegging.'
          : 'Jouw aandeel (' + config.payout.percentage + '%): naar schatting ' + euro(estimate)
            + '. Dit is een schatting op basis van het aantal zakken, geen toezegging.');
      }
    }

    /* ── Winkelwagen ─────────────────────────────────────────────────────── */

    function cartGet() {
      return request('/cart.js?v=' + Date.now(), {
        method: 'GET', headers: { Accept: 'application/json' }, cache: 'no-store'
      }, CART_TIMEOUT_MS);
    }

    function cartPost(path, body) {
      return request(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }, CART_TIMEOUT_MS);
    }

    function bookingLines(cart) {
      var lines = [];
      ((cart && cart.items) || []).forEach(function (item, index) {
        if (String(item.variant_id || item.id) === String(config.variantId)) {
          lines.push({ line: index + 1, item: item });
        }
      });
      return lines;
    }

    function lineProperties(item) {
      var p = (item && item.properties) || {};
      return {
        dateNL: p['Ophaaldatum'] || null,
        dateISO: p['Ophaaldatum (ISO)'] || null,
        slot: p['Tijdslot'] || null,
        bookingId: p['Boekings-ID'] || null
      };
    }

    var CART_ATTRIBUTE_KEYS = [
      'Status', 'Naam', 'Gewenst ophaalmoment', 'Gewenst tijdslot', 'Ophaalmoment (ISO)',
      'Adres', 'Postcode', 'Stad', 'Telefoon', 'E-mail', 'Aantal zakken',
      'Uitbetalingsvoorkeur', 'Boekings-ID', 'Aangevraagd op', 'IBAN', 'Goed doel',
      'Opmerking'
    ];

    function emptyAttributes() {
      var out = {};
      CART_ATTRIBUTE_KEYS.forEach(function (key) { out[key] = ''; });
      return out;
    }

    /* Vergelijkt de teruggelezen winkelwagen met wat de klant heeft gezien.
       Een lege lijst betekent: alles identiek. */
    function compareCart(cart, expected) {
      var differences = [];
      var attributes = (cart && cart.attributes) || {};

      function check(field, want, got, normalise) {
        var a = normalise ? normalise(want) : want;
        var b = normalise ? normalise(got) : got;
        var left = (a === null || a === undefined) ? '' : String(a);
        var right = (b === null || b === undefined) ? '' : String(b);
        if (left !== right) differences.push({ field: field, expected: left, actual: right });
      }

      check('attribuut Ophaalmoment (ISO)', expected.dateISO, attributes['Ophaalmoment (ISO)']);
      check('attribuut Gewenst ophaalmoment', expected.dateNL, attributes['Gewenst ophaalmoment']);
      check('attribuut Gewenst tijdslot', expected.slot, attributes['Gewenst tijdslot'], normaliseSlot);
      check('attribuut Boekings-ID', expected.bookingId, attributes['Boekings-ID']);

      var lines = bookingLines(cart);
      if (lines.length !== 1) {
        differences.push({ field: 'aantal reserveringsproducten', expected: '1', actual: String(lines.length) });
      }
      if (lines.length >= 1) {
        var props = lineProperties(lines[0].item);
        check('property Ophaaldatum (ISO)', expected.dateISO, props.dateISO);
        check('property Ophaaldatum', expected.dateNL, props.dateNL);
        check('property Tijdslot', expected.slot, props.slot, normaliseSlot);
        check('property Boekings-ID', expected.bookingId, props.bookingId);
        if (Number(lines[0].item.quantity) !== 1) {
          differences.push({ field: 'aantal €1-producten', expected: '1', actual: String(lines[0].item.quantity) });
        }
      }
      return differences;
    }

    /* Een eerdere, niet afgerekende aanvraag in de winkelwagen wordt bij een
       nieuw bezoek stilzwijgend opgeruimd.

       Vroeger stond hier een waarschuwing met een knop "Eerdere aanvraag
       verwijderen". Dat legde het probleem bij de klant neer en was daarmee
       precies de verkeerde kant op: als de klant hem niet aanklikte, kon er
       alsnog met een oude datum worden afgerekend via het winkelwagen-icoon.
       Nu gebeurt het automatisch. Nieuwe boeking = schone winkelwagen. */
    function clearStaleBooking() {
      if (!config.variantId) return Promise.resolve();
      return cartGet()
        .then(function (cart) {
          var lines = bookingLines(cart).map(function (l) { return l.line; })
            .sort(function (a, b) { return b - a; });
          if (!lines.length) return null;
          return lines.reduce(function (chain, line) {
            return chain.then(function () { return cartPost('/cart/change.js', { line: line, quantity: 0 }); });
          }, Promise.resolve())
            .then(function () { return cartPost('/cart/update.js', { attributes: emptyAttributes() }); });
        })
        .catch(function () { /* winkelwagen onleesbaar: het verzendpad ruimt sowieso op */ });
    }

    /* ── Verzenden: controleren, vastleggen, dan pas afrekenen ───────────── */

    function newBookingId() {
      var now = new Date();
      var stamp = isoOf(now) + '-' + pad2(now.getHours()) + pad2(now.getMinutes());
      var random = '';
      try {
        var buffer = new Uint8Array(4);
        (window.crypto || window.msCrypto).getRandomValues(buffer);
        for (var i = 0; i < buffer.length; i++) random += ('0' + buffer[i].toString(16)).slice(-2);
      } catch (e) {
        random = Math.random().toString(16).slice(2, 10);
      }
      return 'SNG-' + stamp + '-' + random.toUpperCase();
    }

    function setBusy(busy, label) {
      state.busy = busy;
      if (!refs.payBtn) return;
      refs.payBtn.disabled = busy;
      refs.payBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      refs.payBtn.textContent = busy ? (label || 'Even geduld…') : config.messages.payLabel;
    }

    function blocked(message, title, code) {
      var error = new Error(message);
      error.blocked = true;
      error.title = title;
      error.code = code;
      return error;
    }

    function submit() {
      if (state.busy) return;

      // Alle stappen opnieuw keuren; de klant kan lang op stap 3 hebben gezeten.
      var problems = validateStep1();
      if (problems.length) {
        gotoStep(1, { keepErrors: true, scroll: false });
        showSummary('Je aanvraag is nog niet compleet', problems);
        return;
      }
      problems = validateStep2();
      if (problems.length) {
        gotoStep(2, { keepErrors: true, scroll: false });
        showSummary('Je aanvraag is nog niet compleet', problems);
        return;
      }
      problems = validateStep3();
      if (problems.length) {
        showSummary('Nog één bevestiging nodig', problems);
        return;
      }
      if (!config.variantId) {
        showSummary('Instelling ontbreekt', [{
          message: 'Het reserveringsproduct is niet ingesteld. Neem contact met ons op — dit is een instelling aan onze kant.'
        }]);
        return;
      }

      clearSummary();
      state.bookingId = newBookingId();

      var payoutType = currentPayout();
      var payout = payoutSummary();
      var ibanValue = payoutType === 'bank' ? value('iban').toUpperCase().replace(/\s+/g, ' ') : '';
      var charityValue = payoutType === 'donatie'
        ? (el(root, '[data-charity]:checked') || {}).value || ''
        : '';
      var bags = parseInt(value('bags'), 10) || config.bags.default;
      var submittedAt = new Date();
      // Is er al iets in de winkelwagen geschreven? Zo ja, dan moet een
      // blokkade dat weer opruimen: een niet-geverifieerde regel mag nooit
      // via het winkelwagen-icoon alsnog afgerekend kunnen worden.
      var cartWritten = false;

      var expected = {
        dateISO: state.dateISO,
        dateNL: dutchDate(state.dateISO),
        slot: normaliseSlot(state.slot),
        bookingId: state.bookingId
      };

      /* De 48-uursregel nog één keer met de klok van dit moment: de klant kan
         lang op stap 3 hebben gezeten. Verder is er niets meer te controleren —
         we beloven geen exclusiviteit op het tijdslot. */
      setBusy(true, 'Aanvraag controleren…');

      Promise.resolve()
        .then(function () {
          if (!slotInLeadTime(state.dateISO, state.slot)) {
            throw blocked(config.messages.slotExpired.replace(/\[uren\]/g, config.leadHours),
              'Moment niet meer mogelijk', 'slot_expired');
          }
          // 3. Winkelwagen leegmaken. /cart/clear.js wist regels, niet de
          //    attributen; die overschrijven we hieronder allemaal expliciet.
          setBusy(true, 'Winkelwagen klaarmaken…');
          return cartPost('/cart/clear.js', {});
        })
        .then(function () { return cartGet(); })
        .then(function (cart) {
          if (bookingLines(cart).length) {
            var lines = bookingLines(cart).map(function (l) { return l.line; }).sort(function (a, b) { return b - a; });
            return lines.reduce(function (chain, line) {
              return chain.then(function () { return cartPost('/cart/change.js', { line: line, quantity: 0 }); });
            }, Promise.resolve()).then(cartGet);
          }
          return cart;
        })
        .then(function (cart) {
          if (bookingLines(cart).length) {
            throw blocked(config.messages.verifyFailed, 'Winkelwagen niet leeg', 'cart_not_empty');
          }
          // 4. Het €1-product toevoegen mét de boekingsgegevens als line item
          //    properties: dan reist de datum mee met het product, ook via een
          //    herstelde checkout-link.
          setBusy(true, 'Aanvraag vastleggen…');
          cartWritten = true;
          return cartPost('/cart/add.js', {
            id: config.variantId,
            quantity: 1,
            properties: {
              'Ophaaldatum': expected.dateNL,
              'Ophaaldatum (ISO)': expected.dateISO,
              'Tijdslot': expected.slot,
              'Boekings-ID': expected.bookingId
            }
          });
        })
        .then(function () {
          // 5. Cart-attributen: dezelfde namen die de planning gebruikt.
          //    Niet-gebruikte velden expliciet leegmaken, zodat er geen IBAN
          //    of goed doel van een eerdere aanvraag blijft hangen.
          var attributes = emptyAttributes();
          attributes['Status'] = 'Aanvraag — wacht op controle door de planning';
          attributes['Naam'] = (value('first') + ' ' + value('last')).trim();
          attributes['Gewenst ophaalmoment'] = expected.dateNL;
          attributes['Gewenst tijdslot'] = expected.slot;
          attributes['Ophaalmoment (ISO)'] = expected.dateISO;
          attributes['Adres'] = (value('street') + ' ' + value('house')).trim();
          attributes['Postcode'] = formatPostcode(state.postcode);
          attributes['Stad'] = value('city');
          attributes['Telefoon'] = value('phone');
          attributes['E-mail'] = value('email');
          attributes['Aantal zakken'] = String(bags);
          attributes['Uitbetalingsvoorkeur'] = payout.label;
          attributes['Boekings-ID'] = expected.bookingId;
          attributes['Aangevraagd op'] = submittedAt.toISOString();
          attributes['IBAN'] = ibanValue;
          attributes['Goed doel'] = charityValue;
          attributes['Opmerking'] = value('note');
          return cartPost('/cart/update.js', { attributes: attributes });
        })
        .then(function () {
          // 6. Onafhankelijk teruglezen. Dít is de bron van waarheid.
          setBusy(true, 'Controleren wat is opgeslagen…');
          return cartGet();
        })
        .then(function (cart) {
          var differences = compareCart(cart, expected);
          if (differences.length) {
            throw blocked(config.messages.verifyFailed, 'Controle mislukt', 'verify_mismatch');
          }
          // 7. Nog één keer de voorbereidingstijd, nu op de teruggelezen waarden.
          var attributes = cart.attributes || {};
          var storedISO = attributes['Ophaalmoment (ISO)'];
          var storedSlot = attributes['Gewenst tijdslot'];
          if (!parseISO(storedISO) || !normaliseSlot(storedSlot) || !slotInLeadTime(storedISO, storedSlot)) {
            throw blocked(config.messages.slotExpired.replace(/\[uren\]/g, config.leadHours),
              'Moment niet meer mogelijk', 'slot_expired');
          }

          // 8. Alles klopt: door naar de betaalpagina van Shopify. Hier staat
          //    bewust GEEN bevestigingsscherm — dat komt pas na de betaling.
          setBusy(true, 'Doorsturen naar de betaalpagina…');
          window.location.href = '/checkout';
        })
        .catch(function (error) {
          // Eerst opruimen wat half is opgeslagen, dan pas melden. Zo kan een
          // afgebroken aanvraag niet later via de winkelwagen afgerekend worden.
          if (!cartWritten) return Promise.reject(error);
          return cartGet()
            .then(function (cart) {
              var lines = bookingLines(cart).map(function (l) { return l.line; })
                .sort(function (a, b) { return b - a; });
              return lines.reduce(function (chain, line) {
                return chain.then(function () { return cartPost('/cart/change.js', { line: line, quantity: 0 }); });
              }, Promise.resolve());
            })
            .then(function () { return cartPost('/cart/update.js', { attributes: emptyAttributes() }); })
            .catch(function () { /* opruimen mislukt: de melding hieronder blijft leidend */ })
            .then(function () { return Promise.reject(error); });
        })
        .catch(function (error) {
          setBusy(false);
          var isBlocked = !!(error && error.blocked);

          if (isBlocked && error.code === 'slot_expired') {
            // Alle overige gegevens blijven staan; alleen de tijdkeuze terug.
            state.slot = null;
            renderDates();
            renderTimes();
            gotoStep(1, { keepErrors: true, scroll: false });
            setFieldError('time', error.message);
            showSummary(error.title, [{ field: 'time', message: error.message }]);
            return;
          }
          if (isBlocked) {
            showSummary(error.title || 'Aanvraag niet verstuurd', [{ message: error.message }]);
            return;
          }
          showSummary('Verzenden mislukt', [
            { message: config.messages.networkFailed },
            { message: 'Technische melding: ' + String((error && error.message) || error) }
          ]);
        });
    }

    /* ── Gebeurtenissen ──────────────────────────────────────────────────── */

    config.messages.payLabel = refs.payBtn ? refs.payBtn.textContent.trim() : 'Betaal €1 & verstuur aanvraag';

    // De geocodecache geldt alleen per postcode en per paginabezoek; dezelfde
    // postcode twee keer controleren kost dus geen tweede verzoek aan PDOK.
    if (refs.postcodeBtn) {
      refs.postcodeBtn.addEventListener('click', function () { checkPostcode(); });
    }
    if (refs.postcode) {
      refs.postcode.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); checkPostcode(); }
      });
      refs.postcode.addEventListener('blur', function () {
        var clean = normalisePostcode(refs.postcode.value);
        if (!clean) return;
        refs.postcode.value = formatPostcode(clean);
        if (!POSTCODE_RE.test(clean)) setFieldError('postcode', config.messages.postcodeInvalid);
        else clearFieldError('postcode');
      });
    }

    if (refs.dates) {
      refs.dates.addEventListener('click', function (event) {
        var button = event.target.closest('[data-date]');
        if (button && !button.disabled) selectDate(button.getAttribute('data-date'));
      });
    }
    if (refs.times) {
      refs.times.addEventListener('click', function (event) {
        var button = event.target.closest('[data-slot]');
        if (button && !button.disabled) selectSlot(button.getAttribute('data-slot'));
      });
    }
    if (refs.moreDates) {
      refs.moreDates.addEventListener('click', function () {
        // Puur lokaal: geen wachttijd, dus ook geen laadmelding.
        state.windowDays = Math.min(
          state.windowDays + (config.windowStep || 14),
          schedule.horizonDays
        );
        renderDates();
        announce('Meer data getoond.');
      });
    }

    all(root, '[data-bags-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!refs.bags) return;
        var delta = Number(button.getAttribute('data-bags-step'));
        var next = (parseInt(refs.bags.value, 10) || config.bags.default) + delta;
        refs.bags.value = Math.max(config.bags.min, Math.min(config.bags.max, next));
        clearFieldError('bags');
      });
    });
    if (refs.bags) {
      refs.bags.addEventListener('blur', function () {
        var next = parseInt(refs.bags.value, 10);
        if (isNaN(next)) next = config.bags.default;
        refs.bags.value = Math.max(config.bags.min, Math.min(config.bags.max, next));
        clearFieldError('bags');
      });
    }

    all(root, '[data-payout]').forEach(function (input) {
      input.addEventListener('change', function () { syncPayoutPanels(); });
    });
    all(root, '[data-charity]').forEach(function (input) {
      input.addEventListener('change', function () { clearFieldError('charity'); });
    });

    // Validatie na blur, niet tijdens het typen (handoff §8).
    all(root, 'input[data-field], textarea[data-field]').forEach(function (input) {
      input.addEventListener('blur', function () {
        if (state.step === 2) {
          var name = input.getAttribute('data-field');
          var problems = validateStep2().filter(function (p) { return p.field === name; });
          if (!problems.length) clearFieldError(name);
        }
      });
    });

    all(root, '[data-goto]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = Number(button.getAttribute('data-goto'));
        var focus = button.getAttribute('data-focus');

        // Terug mag altijd; vooruit alleen als de huidige stap klopt.
        if (target > state.step) {
          var problems = state.step === 1 ? validateStep1() : validateStep2();
          if (problems.length) {
            showSummary('Je aanvraag is nog niet compleet', problems);
            return;
          }
        }
        gotoStep(target, { focus: focus });
      });
    });

    if (refs.payBtn) {
      refs.payBtn.addEventListener('click', function (event) { event.preventDefault(); submit(); });
    }
    if (refs.form) {
      refs.form.addEventListener('submit', function (event) { event.preventDefault(); submit(); });
    }

    // Een openstaand tabblad mag geen verlopen moment blijven tonen.
    function refreshTime() {
      if (state.step !== 1 || ['ok', 'ver', 'onbekend', 'nietgevonden'].indexOf(state.postcodeStatus) === -1) return;
      renderDates();
      if (state.dateISO) renderTimes();
    }
    var tick = setInterval(refreshTime, 60000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshTime();
    });
    window.addEventListener('pagehide', function () { clearInterval(tick); });

    window.addEventListener('beforeunload', function (event) {
      if (!state.busy) return;
      event.preventDefault();
      event.returnValue = '';
    });

    /* ── Elke paginalading begint leeg ────────────────────────────────────────
       Browsers zetten ingevulde formulierwaarden terug bij een terugknop en bij
       een herstelde pagina uit de back/forward-cache. Dat is precies wat we
       hier niet willen: dat bezoek is afgelopen en er mogen geen naam, adres,
       e-mail of telefoonnummer van een vorige sessie meer in beeld komen.

       Belangrijk detail: dat terugzetten gebeurt ná `pageshow`. Meteen leegmaken
       helpt dus niet — de browser vult het daarna alsnog opnieuw in. We wachten
       daarom één frame en maken pas daarna leeg.

       Het heen en weer lopen tussen stap 1, 2 en 3 blijft ongemoeid: dat
       gebeurt binnen dezelfde paginalading, zonder pageshow. */

    var hasInteracted = false;
    root.addEventListener('input', function () { hasInteracted = true; }, true);
    root.addEventListener('change', function () { hasInteracted = true; }, true);

    /* Leegmaken op het moment van weggaan. Dit is de betrouwbare kant van het
       verhaal: wat er bij het verlaten van de pagina niet meer in de velden
       staat, kan de browser bij een terugknop ook niet terugzetten. Wachten tot
       ná het herstel werkt niet — dat herstel komt later dan welke timer dan
       ook. Hier houden we bewust wel het veld-niveau `autocomplete` intact,
       zodat de klant zijn adres nog steeds door de browser kan laten invullen. */
    function wipeFields() {
      all(root, 'input[data-field], textarea[data-field]').forEach(function (node) {
        if (node.type === 'checkbox' || node.type === 'radio') node.checked = false;
        else node.value = '';
      });
      all(root, '[data-charity]').forEach(function (node) { node.checked = false; });
      all(root, '[data-payout]').forEach(function (node, index) { node.checked = index === 0; });
    }

    window.addEventListener('pagehide', wipeFields);

    function startFresh(restored) {
      // hasInteracted overleeft een bfcache-herstel; hier telt alleen wat de
      // klant ná dit herstel doet.
      hasInteracted = false;
      requestAnimationFrame(function () {
        setTimeout(function () {
          if (hasInteracted) return;          // klant is al begonnen: niet storen
          resetForm();
          purgeLegacyStorage();
          if (restored) {
            clearStaleBooking();
            announce('Je begint met een lege aanvraag.');
          }
        }, 0);
      });
    }

    window.addEventListener('pageshow', function (event) { startFresh(event.persisted); });

    syncPayoutPanels();
    purgeLegacyStorage();
    clearStaleBooking();

    // Hulp bij support: alleen de toestand, nooit persoonsgegevens.
    root.sngDebug = function () {
      return {
        step: state.step,
        postcode: state.postcode,
        postcodeStatus: state.postcodeStatus,
        dateISO: state.dateISO,
        slot: state.slot,
        weekdays: schedule.weekdays,
        blockedDates: schedule.blocked.length,
        horizonDays: schedule.horizonDays,
        earliestAllowed: new Date(earliestAllowed()).toISOString()
      };
    };
  }

  function boot() {
    all(document, '[data-sng-booking]').forEach(initBooking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor: opnieuw opbouwen als de sectie wordt herladen.
  document.addEventListener('shopify:section:load', function (event) {
    var node = event.target.querySelector('[data-sng-booking]');
    if (node) initBooking(node);
  });
})();
